module.exports = __webpack_public_path__ + "static/media/timeline-4.646ca54f.png";